export default {"src":"/_next/static/media/logo.c977bc6c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};